import(/* webpackMode: "eager" */ "/vercel/path0/src/app/client-access/page.tsx");
